module.exports = "data:image/gif;base64,R0lGODlhCwAKAIAAAEFBQeXl5SH5BAAAAAAALAAAAAALAAoAAAIXjA2nGLl9XFxSqgRc1phpBn1QCG7YFhQAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icon1.gif
// module id = 276
// module chunks = 0